import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-company-modal',
  templateUrl: './company-modal.component.html',
  styleUrls: ['./company-modal.component.scss']
})
export class CompanyModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  data = null
  Success = null

  stateForm = new FormGroup({
    Company_code: new FormControl(null, Validators.required),
    Name: new FormControl('', Validators.required),
    Address1: new FormControl('', Validators.required),
    Address2: new FormControl('', Validators.required),
    Tel_No: new FormControl('', Validators.required),
    Email_Addr: new FormControl('', Validators.required),
    billing_addr: new FormControl('', Validators.required),
    Contact_Person: new FormControl('', Validators.required),
    Contact_person_Designation: new FormControl('', Validators.required),
    Contact_Person_Mobile_No: new FormControl('', Validators.required),
    package_breakup: new FormControl('', Validators.required),
    Payment_Type: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    Dis_Flag: new FormControl('N', Validators.required),
    discount: new FormControl('', Validators.required),
    Remarks: new FormControl('', Validators.required),
    Standard_Price_Valid_Id: new FormControl('', Validators.required),
    Special_Price_Valid_Id: new FormControl('', Validators.required),
  });


  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      Company_code,
      Name,
      Address1,
      Address2,
      Tel_No,
      Email_Addr,
      billing_addr,
      Contact_Person,
      Contact_person_Designation,
      Contact_Person_Mobile_No,
      package_breakup,
      Payment_Type,
      status,
      Dis_Flag,
      discount,
      Remarks,
      Standard_Price_Valid_Id,
      Special_Price_Valid_Id,
    } = this.stateForm.value;
    this.auth
      .postCompany(
        Company_code,
        Name,
        Address1,
        Address2,
        Tel_No,
        Email_Addr,
        billing_addr,
        Contact_Person,
        Contact_person_Designation,
        Contact_Person_Mobile_No,
        package_breakup,
        Payment_Type,
        status,
        Dis_Flag,
        discount,
        Remarks,
        Standard_Price_Valid_Id,
        Special_Price_Valid_Id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }       
            else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
      .getCompanies()
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }
  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.stateForm.patchValue({
      Company_code: title.Company_code,
      Name: title.Name,
      Address1: title.Address1,
      Address2: title.Address2,
      Tel_No: title.Tel_No,
      Email_Addr: title.Email_Addr,
      billing_addr: title.billing_addr,
      Contact_Person: title.Contact_Person,
      Contact_person_Designation: title.Contact_person_Designation,
      Contact_Person_Mobile_No: title.Contact_Person_Mobile_No,
      package_breakup: title.package_breakup,
      Payment_Type: title.Payment_Type,
      status: title.status,
      discount: title.discount,
      Remarks: title.Remarks,
      Standard_Price_Valid_Id: title.Standard_Price_Valid_Id,
      Special_Price_Valid_Id: title.Special_Price_Valid_Id,
    });
    console.log(this.stateForm.value)
  }

  delete(title) {
    this.auth
      .delSet("/api/companies/deleteCompany", title.Company_code)
      .subscribe(
        (resSuccess) => {
          this.titles = this.titles.filter(dattum => dattum.Company_code !== title.Company_code)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }


}
